import axios from 'axios';
import mappedServices from './mappedServices';
import lodash from 'lodash';
import AuthProvider from './authProvider';
import { properties as propertiesCloudConfig } from 'config/Config';

const RestProvider = () => {
    
    const {getToken} = AuthProvider();

    const crudOperationsType = {
        FIND_BY_ID: 'findBy',
        FIND_ALL: 'findAll',
        CREATE: 'create',
        UPDATE: 'update',
        DELETE_BY_ID: 'delete',
        DELETE: 'delete',
        CUSTOM: 'custom',
    }

    /**
     * Hacemos una petición crud por medio de una API rest, devuelve la promesa correspondiente
     * @param {*} sourceMs, el prefijo del mapeo de microservicio
     * @param {*} crudOp, la operación, hacemos uso del enumerado crudOperationsType
     * @param {*} resource, el nombre del endpoint
     * @param {*} params, los parámetros
     */
    const crudOperationEx = async (sourceMs, crudOp, resource, params = {}) => {
        let crudPromise = null;    

        let config = {
            headers: {
            }
        }
    
        let access_token = await getToken();
        config.headers["Authorization"] = `Bearer ${access_token}`;

        if (params.headers) {
            lodash.merge(config.headers, params.headers);
        }

        let contextUrl = propertiesCloudConfig['SERVER_SERVLET_CONTEXT-PATH'] != null ? propertiesCloudConfig['SERVER_SERVLET_CONTEXT-PATH'] : '' ;
        const baseUrl = `${contextUrl}` + (sourceMs && sourceMs.length > 0 ? `${sourceMs}/${resource}` : `/${resource}`);

        switch(crudOp) {
            case crudOperationsType.CREATE:
                crudPromise = axios.post(`${baseUrl}`, params, config);
                break;
            case crudOperationsType.FIND_BY_ID:
                crudPromise = axios.get(`${baseUrl}/${params.id}`, config);
                break;
            case crudOperationsType.FIND_ALL:
                crudPromise = axios.get(`${baseUrl}`, { params, ...config });
                break;
            case crudOperationsType.UPDATE:
                crudPromise = axios.put(`${baseUrl}/${params.id}`, params, config);
                break;
            case crudOperationsType.DELETE_BY_ID:
                crudPromise = axios.delete(`${baseUrl}/${params.id}`, config);
                break;
            case crudOperationsType.CUSTOM:
                const {
                    baseURL = baseUrl,
                    url = '',
                    method = "get",
                    responseType = '',
                    timeout = 0
                } = params;
                crudPromise = axios.request({ baseURL, url, method, params: params.urlParams, data: params.data, responseType, timeout, ...config });
                break;
            default:
                new Error("Acción no soportada");
        }
        // Devuelve la promesa concreta de la petición para controlarla en su destino
        return crudPromise;
    };

    /**
     * Hacemos una petición crud por medio de una API rest, devuelve la promesa correspondiente
     * @param {*} crudOp, la operación, hacemos uso del enumerado crudOperationsType
     * @param {*} resource, el nombre del endpoint
     * @param {*} params, los parámetros
     */
    const crudOperation = (crudOp, resource, params) => {

        let sourceMs = '';
        for (var ms in mappedServices) {
            if (Object.prototype.hasOwnProperty.call(mappedServices, ms)) {
                const resourceMatches = mappedServices[ms].resources.find(r => r === resource);
                if (resourceMatches) {
                    sourceMs = mappedServices[ms].path;
                    break;
                }
            }
        }
        if (sourceMs !== '') {
            return crudOperationEx(sourceMs, crudOp, resource, params);        
        } else {
            new Error(`Microservicio no identificado para el resource ${resource}`);
        }
    };

    return { crudOperationsType, crudOperationEx, crudOperation };
}
export default RestProvider;